import React, {Component} from 'react';
import PropTypes from 'prop-types';
import styled from "styled-components";

import SimpleInputText from "./util/SimpleInputText";
import UtilDom from "../midi/util/UtilDom";

const DEFAULT_STEPS = 100;
const PAUSE = 100;
const STEP_TIME = 100;

const MainWrapper = styled.div`
    margin: 0.5rem 0.5%;
    padding: 0.5rem 0 0.75rem;    
    background-color: #f7f7f7;
    border-radius: 0.25rem;
    border: 0.15rem solid #aaaaaa;
`;

const ControlsWrapper = styled.div`
    padding: 0 1rem;
`;

const VariableWrapper = styled.div`
    font-size: 0.8rem;
    font-weight: bold;
    font-family: Courier;    
    vertical-align: middle;
    padding: 0.15rem 1rem;
`;

const OperationsWrapper = styled.div`
    border-top: 0.15rem solid #aaaaaa;
    margin-top: 0.5rem;
    padding-top: 0.5rem;
`;

const StepsWrapper = styled.div`
    display: inline-block;
`;

const OpButton = styled.button`
    display: inline-block;
    font-weight: bold;
    color: white;
    margin-left: 1rem;    
    margin-top: 1px;    
`;

const GoButton = styled(OpButton)`
    background-color: darkgreen;
`;

const StopButton = styled(OpButton)`
    background-color: darkred;
`;

const StepCounter = styled.div`
    display: inline-block;
    font-size: 0.9rem;
    margin-left: 1rem;
    font-weight: bold;
`;

const VideoPreview = styled.video`
    width: 100%;    
    margin-top: 1rem;    
`;

export class Automation extends Component {

    static propTypes = {
        get_value: PropTypes.func.isRequired,
        set_value: PropTypes.func.isRequired,
        set_all_values: PropTypes.func.isRequired,
        variables: PropTypes.array.isRequired,
        current_values: PropTypes.object.isRequired,
        canvas_ref: PropTypes.object.isRequired,
        enabled: PropTypes.bool.isRequired
    }

    state = {
        new_values: {},
        base_values: {},
        steps: DEFAULT_STEPS,
        running: false,
        current_step: 1,
        video_src: null
    }

    componentDidMount() {
        const new_values = this.init_values();
        this.setState({
            new_values: new_values,
            base_values: new_values,
        });
    }

    init_values() {
        let new_values = {};
        for (let i = 0; i < this.props.variables.length; i++) {
            const variable_name = this.props.variables[i];
            new_values[variable_name] = this.props.get_value(variable_name);
        }
        return new_values;
    }

    on_change_new_value = (variable, evt) => {
        const new_values = this.state.new_values;
        new_values[variable] = evt.target.value;
        this.setState({new_values: new_values});
    }

    on_change_steps = (evt) => {
        this.setState({steps: evt.target.value});
    }

    run = (running) => {
        if (!running) {
            this.setState({running: running});
            return;
        }
        this.setState({
            running: true,
            current_step: 1,
        });
        const new_values = this.props.current_values;
        const base_values = UtilDom.deepCopy(this.state.base_values);

        const steps = this.state.steps;
        const variables = this.props.variables;
        const frames = []
        for (let step = 0; step <= steps; step++) {
            let values = {};
            for (let i = 0; i < variables.length; i++) {
                const variable_name = variables[i];
                const base_value = base_values[variable_name]
                const final_value = new_values[variable_name];
                values[variable_name] = base_value + (final_value - base_value) * step / steps;
            }
            frames.push(values);
        }

        const that = this;
        const rec = this.startRecording();
        for (let step = 0; step <= steps; step++) {
            setTimeout(function () {
                if (!that.state.running) {
                    return;
                }
                const values = frames[step];
                that.setState({
                    current_step: step + 1,
                    current_values: values
                });
                that.props.set_all_values(values);
                if (step >= steps) {
                    rec.stop();
                    that.setState({
                        running: false,
                        current_values: base_values,
                    });
                }
            }, PAUSE + STEP_TIME * step);
        }
    }

    startRecording() {
        const canvas = this.props.canvas_ref.current;
        const stream = canvas.captureStream(50);
        const rec = new MediaRecorder(stream);
        const chunks = [];
        rec.ondataavailable = e => {
            chunks.push(e.data);
        };
        rec.onstop = e => this.exportVid(chunks);

        rec.start(25);
        return rec;
    }

    exportVid(chunks) {
        console.log("how many chunks?", chunks.length)
        var blob = new Blob(chunks, {type: 'video/mp4; codecs="avc1.64001E, mp4a.40.2"'});
        var url = URL.createObjectURL(blob);
        this.setState({video_src: url})
        // "C:\Program Files\ffmpeg\bin\ffmpeg" -i input.mp4 output.mp4
    }

    render() {
        const variables = !this.props.enabled ? '' :
            this.props.variables.map((variable, index) => {
                if (!this.state.running) {
                    const base_value = this.state.base_values[variable];
                    const new_value = <SimpleInputText
                        initial_value={this.props.current_values[variable]}
                        on_change={evt => this.on_change_new_value(variable, evt)}
                        size={3}
                    />
                    return <VariableWrapper key={"automation_variable_" + index}>
                        {variable}: {base_value} to {new_value}
                    </VariableWrapper>
                }
                const current_value = this.props.current_values[variable];
                return <VariableWrapper key={"automation_variable_" + index}>
                    {variable}: {current_value}
                </VariableWrapper>
            });
        const steps = <StepsWrapper>steps:
            <SimpleInputText
                initial_value={this.state.steps}
                on_change={evt => this.on_change_steps(evt)}
                size={3}
            />
        </StepsWrapper>
        const button = this.state.running ?
            <StopButton onClick={e => this.run(false)}>STOP</StopButton> :
            <GoButton onClick={e => this.run(true)}>GO</GoButton>
        const step_counter = !this.state.running ? '' :
            <StepCounter>{this.state.current_step}/{this.state.steps}</StepCounter>
        const operations = <OperationsWrapper>
            {steps}
            {button}
            {step_counter}
        </OperationsWrapper>

        const video_preview = !this.state.video_src ? '' :
            <VideoPreview src={this.state.video_src} controls loop/>;

        const expanded = !this.props.enabled ? '' :
            <ControlsWrapper>
                {variables}
                {operations}
                {video_preview}
            </ControlsWrapper>;
        return <MainWrapper>
            {expanded}
        </MainWrapper>
    }
}

export default Automation;
